import { Route, Routes } from "react-router-dom"
import AgencyList from "./components/AgencyList"

export default function AgenciesPage() {
  return (
    <Routes>
      <Route index element={<AgencyList />} />
      <Route path=":id" element={<AgencyList />} />
    </Routes>
  )
}
